import { Effect } from "../../Materials/effect";
var name = 'fresnelFunction';
var shader = "#ifdef FRESNEL\nfloat computeFresnelTerm(vec3 viewDirection,vec3 worldNormal,float bias,float power)\n{\nfloat fresnelTerm=pow(bias+abs(dot(viewDirection,worldNormal)),power);\nreturn clamp(fresnelTerm,0.,1.);\n}\n#endif";
Effect.IncludesShadersStore[name] = shader;
/** @hidden */
export var fresnelFunction = { name: name, shader: shader };
//# sourceMappingURL=fresnelFunction.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babylonjs/core/Shaders/ShadersInclude/fresnelFunction.js
// module id = null
// module chunks = 